import { render, staticRenderFns } from "./webAndSocial.vue?vue&type=template&id=0e5c2708&scoped=true"
import script from "./webAndSocial.vue?vue&type=script&lang=js"
export * from "./webAndSocial.vue?vue&type=script&lang=js"
import style0 from "./webAndSocial.vue?vue&type=style&index=0&id=0e5c2708&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e5c2708",
  null
  
)

export default component.exports